<template>
  <div>
    <v-container
      grid-list-xl
      fluid
    >
      <v-layout
        row
        wrap
        class="mt-3"
      >
        <v-toolbar
          flat
          color="transparent"
          class="mb-4 mt-4"
          height="20px"
        >
          <v-btn
            icon
            class="text--secondary"
            @click="goBack"
          >
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <span class="text-capitalize subheading text--secondary">
            {{ $t('Settings') }}
          </span>
        </v-toolbar>

        <tax-settings
          v-if="taxSettings"
          :settings="taxSettings"
          @updated="updateTaxSettings"
        />
        <vat-rates-list
          :disabled="taxType !== 'vat'"
        />
        <tax-rates-list
          :taxes="taxRates"
          :disabled="taxType !== 'sales'"
          @refreshTaxes="reinitializeTaxGroups"
        />
        <tax-groups-list
          :disabled="taxType !== 'sales'"
          :tax-rates="taxRates"
          :tax-groups="taxGroups"
          :zones="zones"
          :taxonomy-tree="taxonomyTree"
          :taxonomy="taxonomy"
          :customer-groups="customerGroups"
          @refreshTaxes="setTaxGroups"
        />
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import TaxGroupsList from '@/modules/Settings/components/Taxes/TaxGroupsList'
import TaxRatesList from '@/modules/Settings/components/Taxes/TaxRatesList'
import TaxSettings from '@/modules/Settings/components/Taxes/TaxSettings'
import Services from '@/modules/Settings/service'
import VatRatesList from '@/modules/Settings/components/Taxes/VatRatesList'

export default {
  name: 'SettingsTaxes',

  actionBar () {
    return {
      title: 'Taxes Settings'
    }
  },

  components: {
    VatRatesList,
    TaxGroupsList,
    TaxRatesList,
    TaxSettings
  },

  data () {
    return {
      taxRates: null,
      taxGroups: null,
      zones: null,
      taxonomyTree: [],
      taxonomy: null,
      customerGroups: [],
      taxSettings: null
    }
  },

  computed: {
    taxType () {
      return this.taxSettings ? this.taxSettings.type : ''
    }
  },

  async created () {
    this.taxSettings = await this.$http.make('general_settings').find('taxes')

    await this.$http.taxonomy
      .include(['children'])
      .fetch(items => {
        this.taxonomyTree = this.taxonomyTree.concat(items.filter(taxon => !taxon.parent_id))
        this.taxonomy = items
      })

    const [taxRates, zones] = await Promise.all([
      Services.loadTaxRates(),
      Services.loadZones()
    ])

    this.customerGroups = [{ code: null, name: 'None' }, ...await this.$http.make('customer:group').get()]

    this.taxRates = await taxRates
    this.setTaxGroups()
    this.zones = zones
  },

  methods: {
    updateTaxSettings (data) {
      let taxSetting = this.$http.make('general_settings', { data: data })
      taxSetting.code_url = 'taxes'

      try {
        taxSetting.save()
        this.$toast(this.$t('Tax settings updated'))
      } catch (e) {
        this.$vuetify.goTo(0)
        this.$toast.error(this.$t(e.message))
      }
    },

    goBack () {
      this.$router.push({ name: 'settings' })
    },

    async reinitializeTaxGroups () {
      this.taxGroups = null
      await this.setTaxRates()
      this.setTaxGroups()
    },

    async setTaxRates () {
      this.taxRates = null
      this.taxRates = await Services.loadTaxRates()
    },

    async setTaxGroups () {
      this.taxGroups = null
      const taxGroups = await Services.loadTaxGroups()
      this.taxGroups = taxGroups.map(group => {
        group.rates = group.tax_rate_ids.map(rateId =>
          this.taxRates.find(taxRate => taxRate.id === rateId)
        )
        group.rates = group.rates.filter(rate => rate)
        return group
      })
    }
  }
}
</script>
